/**
 * @file: useShakeEffect.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { SafeHaptics } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import {
  Easing,
  runOnJS,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated';

export const useShakeEffect = (
  offset = 10,
  options?: { haptics?: boolean },
) => {
  const translateX = useSharedValue(0);
  const shakeStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: translateX.value }],
  }));
  const shake = usePersistFn((callback?: () => void) => {
    if (options?.haptics !== false) {
      SafeHaptics.impact();
    }
    translateX.value = withRepeat(
      withSequence(
        withTiming(offset, { duration: 50, easing: Easing.linear }),
        withTiming(-offset, { duration: 50, easing: Easing.linear }),
      ),
      3,
      true,
      () => {
        translateX.value = 0;
        if (callback != null) {
          runOnJS(callback)();
        }
      },
    );
  });
  return { shakeStyle, shake };
};
